// DiscussionsContext.js
import { createContext, useContext, useState, useCallback } from "react";

const DiscussionsContext = createContext();


export const DiscussionsProvider = ({ children }) => {
  const [discussions, setDiscussions] = useState([]);
  const [messagesCache, setMessagesCache] = useState({});
const reset = useCallback(() => { setDiscussions([]); setMessagesCache({}); }, []);
  return (
    <DiscussionsContext.Provider value={{ discussions, setDiscussions, messagesCache, setMessagesCache, reset }}>
      {children}
    </DiscussionsContext.Provider>
  );
};

export const useDiscussions = () => useContext(DiscussionsContext);
